export default "__VITE_PUBLIC_ASSET__a7c00e6e__"